import { loadCacheFromLocalStorage } from '../../../../helpers/localStorage';
import { INITIAL_PAGE, INITIAL_SORT, INITIAL_FILTERS, ALL_COLUMNS } from '../constants';

export const getInitialFilters = (trackedObjectId, trackedObjectType) => {
  const filters = JSON.parse(JSON.stringify(INITIAL_FILTERS));

  if (trackedObjectId && trackedObjectType) {
    filters.values.trackedObjectId = trackedObjectId;
    filters.values.trackedObjectType = trackedObjectType;
    filters.active.building = false;
    filters.active.territory = false;
    filters.active.visitType = false;
  }

  return filters;
};

export const getInitialColumns = (trackedObjectId) => {
  if (trackedObjectId) {
    // In embedded views, hide trackedObjectType and buildingName columns as they're redundant
    return ALL_COLUMNS.filter((column) => column !== 'trackedObjectType' && column !== 'buildingName');
  }

  return ALL_COLUMNS;
};

const withIdColumn = (columns) => (columns.includes('id') ? columns : ['id', ...columns]);

export const getInitialData = (cacheKey, trackedObjectId, trackedObjectType, hasMultiTimezone) => {
  const cache = loadCacheFromLocalStorage(cacheKey);
  let filters = cache?.filters || getInitialFilters(trackedObjectId, trackedObjectType);
  let columns = cache?.columns ? withIdColumn(cache.columns) : getInitialColumns(trackedObjectId);

  if (trackedObjectId && trackedObjectType) {
    filters = {
      ...filters,
      values: {
        ...filters.values,
        trackedObjectId,
        trackedObjectType
      },
      active: {
        ...filters.active,
        building: false,
        territory: false,
        visitType: false
      }
    };

    if (cache?.columns) {
      columns = withIdColumn(cache.columns).filter(
        (column) => column !== 'trackedObjectType' && column !== 'buildingName'
      );
    }
  }

  if (!hasMultiTimezone) {
    filters = {
      ...filters,
      values: {
        ...filters.values,
        timeZone: []
      }
    };
  }

  return {
    page: cache?.page || INITIAL_PAGE,
    sort: cache?.sort || INITIAL_SORT,
    filters,
    columns,
    selectAll: false,
    selectedIds: []
  };
};
